module.exports = __webpack_public_path__ + "img/pic_administration_operate.f6a58f6d.jpg";